<template>
  <div class="hm-brand-selector">
    <div class="brand-select flex item-center">
      <el-input
        v-if="!selectedName"
        size="small"
        readonly
        :placeholder="placeholder"
        style="width: 215px"
        @focus="openDialog"
      ></el-input>
      <el-tag v-else size="small" closable @close="clear">{{ selectedName }}</el-tag>
      <el-button class="btn" size="small" @click="$emit('add')" icon="hmicon icon-hao">新建品牌</el-button>
    </div>
    <el-dialog
      title="选择品牌"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <div class="mb10 flex item-center">
        <el-input
          v-model.trim="keyword"
          size="small"
          placeholder="输入品牌名称搜索"
          style="width: 260px"
          @input="debouncedSearch"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button size="small" type="primary" class="ml10" @click="handleSearch">搜索</el-button>
      </div>
      <el-table
        :data="list"
        height="400"
        v-loading="loading"
        highlight-current-row
        @row-click="select"
        style="cursor: pointer"
      >
        <el-table-column prop="brandName" label="品牌名称"></el-table-column>
      </el-table>
      <div class="hm-pagination mt10">
        <el-pagination
          background
          :total="total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next"
          :current-page.sync="pageNo"
          :page-sizes="pageSizes"
          :page-size="pageSize"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "HmBrandSelector",
  props: {
    value: {
      type: String,
      default: ""
    },
    brandName: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择商品品牌"
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50]
    }
  },
  data() {
    return {
      dialogVisible: false,
      keyword: "",
      list: [],
      total: 0,
      pageSize: 20,
      pageNo: 1,
      loading: false
    };
  },
  computed: {
    selectedName() {
      return this.brandName;
    }
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 300);
  },
  beforeDestroy() {
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
  },
  methods: {
    openDialog() {
      this.keyword = "";
      this.pageNo = 1;
      this.dialogVisible = true;
      this.queryList();
    },
    async queryList() {
      this.loading = true;
      try {
        const { result } = await this.$store.dispatch("queryBrandAllList", {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
          keyWords: this.keyword
        });
        if (result) {
          this.list = result.records || [];
          this.total = result.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pageNo = 1;
      this.queryList();
    },
    handlePageChange(page) {
      this.pageNo = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNo = 1;
      this.queryList();
    },
    select(row) {
      this.$emit("input", row.brandId);
      this.$emit("change", row);
      this.dialogVisible = false;
      this.dispatchElFormItem("change");
    },
    clear() {
      this.$emit("input", "");
      this.$emit("change", null);
      this.dispatchElFormItem("change");
    },
    dispatchElFormItem(event) {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName === "ElFormItem") {
          parent.$emit("el.form.change", this.value);
          return;
        }
        parent = parent.$parent;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hm-brand-selector {
  .brand-select {
    .el-input {
      width: 215px;
    }
    .el-tag {
      margin-right: 10px;
    }
  }
}
</style>
